<fieldset *ngIf="!renderedFormService.isSubmitting && !submitted">
  <ng-container *ngIf="valid">
    <h1>Confirm profile details</h1>
    <fl-form-single [forceReadonly]="true" [form]="splicedForm"></fl-form-single>
  </ng-container>

  <h1 *ngIf="!valid">Investor Account Onboarding</h1>

  <footer>
    <ng-container *ngIf="valid; else notValid">
      <p>
        By clicking "Profile is Correct" you confirm that the provided details are correct.
      </p>

      <div class="controls">
        <button [disabled]="isSubmitting$ | async" class="edit" (click)="next()">Edit Profile</button>
        <button [disabled]="isSubmitting$ | async" class="submit" (click)="confirmProfile()">Profile is Correct</button>
      </div>
    </ng-container>
    <ng-template #notValid>
      <p>
        The profile you selected is missing a few key pieces of information. Please update in order to continue.
      </p>

      <div class="controls">
        <button [disabled]="isSubmitting$ | async" class="submit" (click)="next()">Update Profile</button>
      </div>
    </ng-template>

    <a (click)="revertSelectedProfile()">Or go back and select or create new profile.</a>
  </footer>
</fieldset>
